export const urlLogin = () => "/login";
export const urlHome = () => "/";
export const urlSelectCategory = () => "/category";
export const urlSelectProduct = (category: string) =>
  `/category/${category}/product`;
export const urlSuccess = () => "/success";
export const urlScanProduct = () => "/scan-product";
export const urlLoadProduct = (field?: string) =>
  `/load-product${field ? `/${field}` : ""}`;
export const urlRegisterPlayer = () => "/register-player";
export const urlRegisterPlayerLastName = () => "/register-player/last-name";
export const urlRegisterPlayerPhone = () => "/register-player/phone";
export const urlRegisterPlayerSuccess = () => "/register-player/success";
